import axios from 'axios';

export class UploadFile {
   static async uploadFile(url, file) {
      try {
         let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url,
            headers: {
               'Content-Type': 'application/octet-stream',
            },
            data: file,
         };

         const response = await axios.request(config);
         return response;
      } catch (error) {
         console.log(error);
         return error;
      }
   }
   static async azureUploadFile(url, file) {
      try {
         const response = await axios.put(url, file, {
            headers: {
              'x-ms-blob-type': 'BlockBlob',
              'Content-Type': file.type
            }
          });
        return response;
      } catch (error) {
        console.log(error);
        return error;
      }
    }    
}